(function() {
  'use strict';

  let linkedInterfaceSyncTimer = null;
  let unitPriceBadgeObserver = null;
  let unitPriceBadgeSyncTimer = null;

  const unitPriceBadgeSuffixes = {
    en: '/Unit. Auto-applied in Cart',
    de: '/Stk. Rabatt im Warenkorb',
    fr: '/unité. Remise au panier',
    it: '/pz. Sconto al carrello',
    es: '/ud. Descuento en carrito',
    nl: '/stuk. Korting in winkelwagen',
    tr: '/adet. İndirim sepette'
  };

  function initVariantSelectors() {
    document.removeEventListener('click', handleVariantClick);
    document.addEventListener('click', handleVariantClick);
    document.removeEventListener('keydown', handleVariantKeydown);
    document.addEventListener('keydown', handleVariantKeydown);
  }

  function handleVariantClick(e) {
    const colorSwatch = e.target.closest('.color-swatch');
    if (colorSwatch) {
      handleColorSwatchClick(colorSwatch, e);
      return;
    }

    const variantCard = e.target.closest('.variant-card');
    if (variantCard) {
      handleVariantCardClick(variantCard, e);
      return;
    }
  }

  function handleVariantKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const colorSwatch = e.target.closest('.color-swatch');
    if (colorSwatch) {
      handleColorSwatchClick(colorSwatch, e);
      return;
    }

    const variantCard = e.target.closest('.variant-card');
    if (variantCard) {
      handleVariantCardClick(variantCard, e);
    }
  }

  function handleColorSwatchClick(swatch, e) {
    e.preventDefault();

    const selectedValue = swatch.dataset.value;
    const optionContainer = swatch.closest('.product-option-color');
    const optionName = optionContainer.dataset.optionName;

    const allSwatches = optionContainer.querySelectorAll('.color-swatch');
    allSwatches.forEach(s => {
      s.classList.remove('active');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('active');
    swatch.setAttribute('aria-pressed', 'true');

    updateColorValueLabels(optionContainer, swatch.dataset.displayValue || selectedValue);

    updateNativeVariantSelector(optionName, selectedValue);

    scheduleLinkedInterfaceSync();
  }

  function updateColorValueLabels(container, value) {
    container.querySelectorAll('[data-option-value-label]').forEach(label => {
      label.textContent = value;
    });
  }

  function handleVariantCardClick(card, e) {
    e.preventDefault();

    const optionValue = card.dataset.optionValue;
    const container = card.closest('.variant-cards');
    const optionName = container.dataset.optionName;

    const allCards = container.querySelectorAll('.variant-card');
    allCards.forEach(c => c.classList.remove('active'));
    card.classList.add('active');

    updateNativeVariantSelector(optionName, optionValue);
    scheduleLinkedInterfaceSync();
  }

  function updateNativeVariantSelector(optionName, optionValue) {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return false;

    const optionHandle = optionName.toLowerCase().replace(/\s+/g, '-');
    const targetFieldset = variantSelectsEl.querySelector(`fieldset.hidden-native-selector[data-handle="${optionHandle}"]`);

    if (!targetFieldset) return false;

    const radioInputs = targetFieldset.querySelectorAll('input[type="radio"]');
    let targetRadio = null;

    radioInputs.forEach(radio => {
      if (radio.value === optionValue) {
        targetRadio = radio;
        radio.checked = true;
      }
    });

    if (targetRadio) {
      const changeEvent = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      targetRadio.dispatchEvent(changeEvent);
      return true;
    }

    return false;
  }

  function getCurrentOptionSelections() {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return {};

    const selections = {};
    const allFieldsets = variantSelectsEl.querySelectorAll('fieldset[data-index]');

    allFieldsets.forEach(fieldset => {
      const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const optionName = checkedRadio.name.replace('--sticky', '');
        selections[optionName] = checkedRadio.value;
      }
    });

    return selections;
  }

  function getVariantSelectsEl() {
    return document.querySelector('variant-selects:not([data-sticky])');
  }

  function getVariantData() {
    const variantSelectsEl = getVariantSelectsEl();
    if (!variantSelectsEl) return [];

    const dataEl = variantSelectsEl.querySelector('[type="application/json"]');
    if (!dataEl) return [];

    try {
      return JSON.parse(dataEl.textContent);
    } catch (error) {
      return [];
    }
  }

  function syncColorAvailabilityStates() {
    const variants = getVariantData();
    if (!variants.length) return;

    const currentSelections = getCurrentOptionSelections();
    const variantSelectsEl = getVariantSelectsEl();
    if (!variantSelectsEl) return;

    const fieldsets = Array.from(variantSelectsEl.querySelectorAll('fieldset[data-index]'));

    document.querySelectorAll('.product-option-color--compact').forEach(container => {
      const optionName = container.dataset.optionName;
      let optionIndex = Number.parseInt(container.dataset.optionIndex, 10);
      if (Number.isNaN(optionIndex)) {
        optionIndex = fieldsets.findIndex(fieldset => {
          const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
          return checkedRadio && checkedRadio.name.replace('--sticky', '') === optionName;
        });
      }

      if (optionIndex < 0) return;

      container.querySelectorAll('.color-swatch').forEach(swatch => {
        const selectedValue = swatch.dataset.value;
        const matchingVariant = variants.find(variant => {
          return variant.options.every((optionValue, index) => {
            if (index === optionIndex) return optionValue === selectedValue;

            const fieldset = fieldsets[index];
            const checkedRadio = fieldset ? fieldset.querySelector('input[type="radio"]:checked') : null;
            const selectedOptionName = checkedRadio ? checkedRadio.name.replace('--sticky', '') : null;
            const selectedOptionValue = selectedOptionName ? currentSelections[selectedOptionName] : null;
            return !selectedOptionValue || optionValue === selectedOptionValue;
          });
        });

        let state = 'unavailable';
        if (matchingVariant) {
          swatch.dataset.variantId = matchingVariant.id;
          state = matchingVariant.available ? 'available' : 'sold-out';
        }

        swatch.dataset.available = state === 'available' ? 'true' : 'false';
        swatch.dataset.availabilityState = state;
        swatch.classList.toggle('unavailable', state !== 'available');
        swatch.classList.toggle('sold-out', state === 'sold-out');
        swatch.classList.toggle('option-unavailable', state === 'unavailable');
      });
    });
  }

  function getSelectedVariantFromCurrentOptions() {
    const variants = getVariantData();
    if (!variants.length) return null;

    const variantSelectsEl = getVariantSelectsEl();
    if (!variantSelectsEl) return null;

    const selectedOptions = Array.from(variantSelectsEl.querySelectorAll('fieldset[data-index]')).map(fieldset => {
      const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedRadio) return checkedRadio.value;

      const select = fieldset.querySelector('select');
      return select ? select.value : null;
    });

    if (selectedOptions.some(value => value == null)) return null;

    return variants.find(variant => {
      return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
    }) || null;
  }

  function forceVariantSelectionFromCurrentOptions() {
    const variantSelectsEl = getVariantSelectsEl();
    if (!variantSelectsEl) return null;

    if (typeof variantSelectsEl.updateOptions === 'function') variantSelectsEl.updateOptions();
    if (typeof variantSelectsEl.updateMasterId === 'function') variantSelectsEl.updateMasterId();

    const selectedVariant = variantSelectsEl.currentVariant || getSelectedVariantFromCurrentOptions();
    if (!selectedVariant) return null;

    const sectionId = variantSelectsEl.dataset.section;
    const currentVariantInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
    let variantInputChanged = false;

    if (currentVariantInput && String(currentVariantInput.value) !== String(selectedVariant.id)) {
      if (typeof variantSelectsEl.updateVariantInput === 'function') {
        variantSelectsEl.updateVariantInput();
      } else {
        currentVariantInput.value = selectedVariant.id;
        currentVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      variantInputChanged = true;
    }

    if (typeof variantSelectsEl.updateMedia === 'function') variantSelectsEl.updateMedia();
    if (variantInputChanged && variantSelectsEl.dataset.updateUrl === 'true' && typeof variantSelectsEl.updateURL === 'function') {
      variantSelectsEl.updateURL();
    }
    if (variantInputChanged && typeof variantSelectsEl.renderProductInfo === 'function') variantSelectsEl.renderProductInfo();
    if (typeof variantSelectsEl.updateVariantText === 'function') variantSelectsEl.updateVariantText();
    if (typeof variantSelectsEl.updateOther === 'function') variantSelectsEl.updateOther();

    if (variantInputChanged && typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('product:variant-change', {
        variant: selectedVariant,
        sectionId
      });
    }

    return selectedVariant;
  }

  function syncVariantCardsWithCurrentVariant(selectedVariant) {
    const currentSelections = getCurrentOptionSelections();

    document.querySelectorAll('.variant-cards').forEach(container => {
      const optionName = container.dataset.optionName;
      const selectedOptionValue = currentSelections[optionName];
      const visibleCards = Array.from(container.querySelectorAll('.variant-card')).filter(card => card.style.display !== 'none');

      let activeCard = null;
      if (selectedVariant) {
        activeCard = visibleCards.find(card => String(card.dataset.variantId) === String(selectedVariant.id));
      }
      if (!activeCard && selectedOptionValue) {
        activeCard = visibleCards.find(card => card.dataset.optionValue === selectedOptionValue);
      }

      visibleCards.forEach(card => {
        card.classList.toggle('active', card === activeCard);
      });
    });
  }

  function syncBundleMainProduct(selectedVariant) {
    if (!selectedVariant) return;

    document.querySelectorAll('product-bundle-builder [data-main-product-variant]').forEach(select => {
      const option = Array.from(select.options).find(item => String(item.value) === String(selectedVariant.id));
      if (!option) return;

      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncLinkedProductInterfaces() {
    syncColorSwatchesWithCurrentSelection();
    syncColorAvailabilityStates();
    filterVariantCards();

    const selectedVariant = forceVariantSelectionFromCurrentOptions();
    syncVariantCardsWithCurrentVariant(selectedVariant);
    syncBundleMainProduct(selectedVariant);
    normalizeVariantUnitPriceBadges();
  }

  function scheduleLinkedInterfaceSync(delay = 20) {
    window.clearTimeout(linkedInterfaceSyncTimer);
    linkedInterfaceSyncTimer = window.setTimeout(syncLinkedProductInterfaces, delay);
  }

  function scheduleUnitPriceBadgeNormalization(delay = 80) {
    window.clearTimeout(unitPriceBadgeSyncTimer);
    unitPriceBadgeSyncTimer = window.setTimeout(normalizeVariantUnitPriceBadges, delay);
  }

  function getUnitPriceBadgeLocale() {
    const pathLocale = window.location.pathname.split('/').filter(Boolean)[0];
    if (pathLocale && unitPriceBadgeSuffixes[pathLocale.toLowerCase()]) {
      return pathLocale.toLowerCase();
    }

    const htmlLocale = (document.documentElement.lang || '').toLowerCase().split(/[-_]/)[0];
    if (htmlLocale && unitPriceBadgeSuffixes[htmlLocale]) {
      return htmlLocale;
    }

    return 'en';
  }

  function normalizeVariantUnitPriceBadges() {
    const suffix = unitPriceBadgeSuffixes[getUnitPriceBadgeLocale()] || unitPriceBadgeSuffixes.en;

    document.querySelectorAll('.variant-card__badges .badge--free-bonus, .variant-card__badges .badge--single-unit, .variant-card__badges .badge--screen-unit').forEach(badge => {
      const moneyEl = badge.querySelector('.transcy-money');
      if (!moneyEl) return;

      if (
        badge.childNodes.length === 2 &&
        badge.firstChild === moneyEl &&
        badge.lastChild.nodeType === Node.TEXT_NODE &&
        badge.lastChild.textContent === suffix
      ) {
        return;
      }

      badge.replaceChildren(moneyEl, document.createTextNode(suffix));
    });
  }

  function initUnitPriceBadgeObserver() {
    normalizeVariantUnitPriceBadges();

    if (unitPriceBadgeObserver) return;

    unitPriceBadgeObserver = new MutationObserver(mutations => {
      if (mutations.some(mutation => {
        const target = mutation.target.nodeType === Node.TEXT_NODE ? mutation.target.parentElement : mutation.target;
        return target && target.closest && target.closest('.variant-card__badges');
      })) {
        scheduleUnitPriceBadgeNormalization();
      }
    });

    unitPriceBadgeObserver.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function filterVariantCards() {
    const currentSelections = getCurrentOptionSelections();

    document.querySelectorAll('.variant-cards').forEach(container => {
      const optionName = container.dataset.optionName;
      const allCards = container.querySelectorAll('.variant-card');

      allCards.forEach(card => {
        const cardOption1 = card.dataset.option1;
        const cardOption2 = card.dataset.option2;
        const cardOption3 = card.dataset.option3;

        let shouldShow = true;

        for (const [selectedOptionName, selectedValue] of Object.entries(currentSelections)) {
          if (selectedOptionName === optionName) {
            continue;
          }

          let cardValue = null;

          const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
          const allFieldsets = Array.from(variantSelectsEl.querySelectorAll('fieldset[data-index]'));

          allFieldsets.forEach((fieldset, index) => {
            const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
            if (checkedRadio && checkedRadio.name === selectedOptionName) {
              if (index === 0) cardValue = cardOption1;
              else if (index === 1) cardValue = cardOption2;
              else if (index === 2) cardValue = cardOption3;
            }
          });

          if (cardValue && cardValue !== selectedValue) {
            shouldShow = false;
            break;
          }
        }

        if (shouldShow) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
          if (card.classList.contains('active')) {
            card.classList.remove('active');
          }
        }
      });

      const visibleCards = Array.from(allCards).filter(c => c.style.display !== 'none');
      const hasActiveCard = visibleCards.some(c => c.classList.contains('active'));

      if (visibleCards.length > 0 && !hasActiveCard) {
        const selectedOptionValue = currentSelections[optionName];
        const selectedVisibleCard = visibleCards.find(c => c.dataset.optionValue === selectedOptionValue);
        if (selectedVisibleCard) {
          selectedVisibleCard.classList.add('active');
        }
      }
    });
  }

  function listenToAllOptionChanges() {
    const variantSelectsEl = document.querySelector('variant-selects:not([data-sticky])');
    if (!variantSelectsEl) return;

    variantSelectsEl.addEventListener('change', function(e) {
      scheduleLinkedInterfaceSync(10);
    });
  }

  function listenToThemeVariantChanges() {
    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    variantInput.addEventListener('change', function() {
      scheduleLinkedInterfaceSync(0);
    });
  }

  function syncColorSwatchesWithCurrentSelection() {
    const currentSelections = getCurrentOptionSelections();

    document.querySelectorAll('.product-option-color').forEach(container => {
      const optionName = container.dataset.optionName;
      const selectedValue = currentSelections[optionName];

      if (!selectedValue) return;

      const allSwatches = container.querySelectorAll('.color-swatch');
      allSwatches.forEach(swatch => {
        if (swatch.dataset.value === selectedValue) {
          swatch.classList.add('active');
          swatch.setAttribute('aria-pressed', 'true');
          updateColorValueLabels(container, swatch.dataset.displayValue || selectedValue);
        } else {
          swatch.classList.remove('active');
          swatch.setAttribute('aria-pressed', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initVariantSelectors();
    listenToAllOptionChanges();
    listenToThemeVariantChanges();
    initUnitPriceBadgeObserver();
    scheduleLinkedInterfaceSync(100);
  }

})();
